import React, { useState } from "react";
import { ReactComponent as Trash } from "assets/images/icons/trash.svg";
import { ReactComponent as TrashRound } from "assets/images/icons/trash-round.svg";
import DeleteWatchListModal from "../../modals/DeleteWatchListModal/DeleteWatchListModal";

const DeleteWatchlistButton = ({ id, stock, round, useText, isItem }) => {
	const [showModal, setShowModal] = useState(false);

	const toggle = () => setShowModal((prev) => !prev);

	return (
		<>
			{round ? (
				<TrashRound
					height="20px"
					width="20px"
					onClick={toggle}
					className="pointer"
				/>
			) : useText ? (
				<span onClick={toggle}>Delete List</span>
			) : (
				<Trash onClick={toggle} className="pointer" />
			)}

			{showModal && (
				<DeleteWatchListModal
					id={id}
					stock={stock}
					toggle={toggle}
					isItem={isItem}
				/>
			)}
		</>
	);
};

export default DeleteWatchlistButton;
